import React from 'react';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './styles.module.scss';

export interface QAProps {
  answer: React.ReactNode | string;
  question: string;
}

const LetterIcon = ({ letter }: { letter: string }) => <div className={styles['qa-letter-icon']}>{letter}</div>;

export const QA = ({ answer, question }: QAProps) => (
  <div className={styles['qa-container']}>
    <div className={styles['qa-header']}>
      <LetterIcon letter="Q" />
      <h3 className={styles['question']}>{question}</h3>
    </div>
    <div className={styles['qa-body']}>
      <LetterIcon letter="A" />
      {typeof answer === 'string' ? (
        <div className={styles['answer-container']} dangerouslySetInnerHTML={{ __html: sanitizeHTML(answer) }} />
      ) : (
        <div className={styles['answer-container']}>{answer}</div>
      )}
    </div>
  </div>
);
